import { mdiTrashCanOutline, mdiWaterPump } from '@mdi/js'
import Icon from '@mdi/react'
import { Box, Tooltip } from '@mui/material'
import { FC } from 'react'

import type { EventMarker, EventProgress } from '@/data/source'
import { EVENT_DONE_COLOR } from '@/theme'

export const PROGRESS_COLORS: Record<EventProgress, string> = {
  NOT_STARTED: '#9CA3AF',
  IN_PROGRESS: '#2563EB',
  DONE: EVENT_DONE_COLOR,
}

export interface EventMarkerIconProps {
  marker: EventMarker
  label: string
  size?: number
  tooltip?: boolean
}

export const EventMarkerIcon: FC<EventMarkerIconProps> = ({ marker, label, size = 24, tooltip = true }) => {
  const circle = (
    <Box
      data-testid={`event-marker-${marker.id}`}
      role="img"
      aria-label={label}
      sx={{
        width: size + 8,
        height: size + 8,
        borderRadius: '50%',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        bgcolor: PROGRESS_COLORS[marker.progress],
        color: '#ffffff',
        fontSize: size * 0.45,
        fontWeight: 'bold',
        lineHeight: 1,
      }}
    >
      {marker.muelle ?? (
        <Icon path={marker.type === 'MARPOL' ? mdiTrashCanOutline : mdiWaterPump} size={`${String(size - 6)}px`} color="#ffffff" />
      )}
    </Box>
  )
  return tooltip ? <Tooltip title={label}>{circle}</Tooltip> : circle
}
